import { useEffect, useState } from "react";

function unmarked(key: string): boolean {
  try {
    return localStorage.getItem(key) === null;
  } catch {
    return false;
  }
}

/**
 * Once per device: true the first time `key` is shown while `when` holds, and for the rest of that
 * view; a Club look's "New" mark and its "trial ended" note (review 0015 S7, S9).
 */
export function useOnce(key: string, when: boolean): boolean {
  // Read per key on first sight, before this view's mark is written.
  const [firstSight] = useState(() => new Map<string, boolean>());
  if (!firstSight.has(key)) firstSight.set(key, unmarked(key));
  useEffect(() => {
    if (!when) return;
    try {
      localStorage.setItem(key, "1");
    } catch {
      // Without storage the mark shows again next time; nothing breaks.
    }
  }, [key, when]);
  return firstSight.get(key) === true && when;
}
